export default __webpack_public_path__ + "static/Testing-and-Deployment-b70c449269925a15aeace83a462b5452.webp";